// this formula and its coefficients were generated empirically to achieve optimal results
const getLineHeightByFontSize = (fontSize) => `${6.7504 / fontSize + 1.2415}em`;

export default getLineHeightByFontSize;
